(() => {
  const selectors = {
    slider: '.js-product-tabs__content-list-wrapper-slider',
    tab: '.js-togle-product-tab',
    sliderArrows: '.js-product-tabs__content-slider-arrows',
    prevArrow: '.product-tabs__content-slider-arrow--left',
    nextArrow: '.product-tabs__content-slider-arrow--right',
    sectionName: '.product-tabs',
    formInput: '.js-product-card-ds__content-form-input',
    cartCount: '.cart-link__bubble',
    cartPopUp: '.cart-popup',
    productForm: '.product-card-ds__content-form',
    sliderClass: 'product-tabs__content-list-wrapper',

    tabActiveClass: 'product-tabs__content-header-item--active',
    sliderActiveClass: 'product-tabs__content-list-wrapper--active',
  };


  const changeSlider = (event) => {
    const currentTab = event.currentTarget;

    if (currentTab.classList.contains(selectors.tabActiveClass)) {
      return;
    };

    const wrapper = currentTab.closest(selectors.sectionName);
    const activeTab = wrapper.querySelector(`.${selectors.tabActiveClass}`);
    const currentTabData = currentTab.dataset.productTab;
    const activeSlider = wrapper.querySelector(`.${selectors.sliderActiveClass}`);
    const currentSlider = wrapper.querySelector(`.${selectors.sliderClass}[data-product-tab="${currentTabData}"]`);
    const currentActiveSlider = wrapper.querySelector(`${selectors.slider}[data-product-tab="${currentTabData}"]`);

    currentTab.classList.add(selectors.tabActiveClass);
    currentSlider.classList.add(selectors.sliderActiveClass);
    activeTab.classList.remove(selectors.tabActiveClass);
    activeSlider.classList.remove(selectors.sliderActiveClass);


    if (activeSlider.classList.contains(selectors.slider.slice(1))) {
      $(activeSlider).slick('unslick');
    };

    if (currentActiveSlider) {
      reinitSlider(currentSlider);
    };
  };

  const addToCart = async (event) => {
    event.preventDefault();

    const currentForm = event.target;
    const currentVariantID = currentForm.querySelector(selectors.formInput).value;
    const cartPopUp = document.querySelector(selectors.cartPopUp);

    const addToCartPromise = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: currentVariantID,
          quantity: 1
        }]
      }),
    });

    if (addToCartPromise && !addToCartPromise.ok) {
      const errorObject = await addToCartPromise.json();

      throw new Error(errorObject.description);
    } else {
      const numberCounts = document.querySelectorAll(selectors.cartCount);

      numberCounts.forEach((count) => {
        count.innerText = +count.innerText + 1;
        count.classList.add(selectors.cartCountVisibleClass);
      });

      if (cartPopUp) {
        window.showCartPopup();
      };
    }
  };

  const initListeners = () => {
    const tabsArray = document.querySelectorAll(selectors.tab);
    const productForm = document.querySelectorAll(selectors.productForm);

    tabsArray.forEach((tab) => {
      tab.addEventListener('click', changeSlider);
    });

    productForm.forEach((form) => {
      form.addEventListener('submit', addToCart);
    });
  };

  const slickSettings = {
    infinite: false,
    dots: false,
    arrows: true,
    appendArrows: $(`${selectors.sliderArrows}`),
    prevArrow: $(`${selectors.prevArrow}`),
    nextArrow: $(`${selectors.nextArrow}`),
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 2000,
    responsive: [,
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          arrows: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  };

  const initSlider = () => {
    const slider = document.querySelectorAll(`${selectors.slider}.${selectors.sliderActiveClass}`);

    $(slider).slick(slickSettings);
  };

  const reinitSlider = (slider) => {
    $(slider).slick(slickSettings);
  };

  initListeners();
  initSlider();
})();
